import React, { useEffect, useState } from "react";
import API from "./api";

export default function UserSection() {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ name: "", email: "" });
  const [error, setError] = useState("");

  // 1) Load users
  useEffect(() => {
    async function loadUsers() {
      try {
        const res = await API.get("/users");
        setUsers(res.data);
      } catch (err) {
        setError(err.response?.data || err.message);
      }
    }
    loadUsers();
  }, []);

  // 2) Create a new user, then reload
  const handleAdd = async () => {
    if (!form.name || !form.email) return alert("Both fields required");
    if (!window.confirm(`Create user ${form.name}?`)) return;
    try {
      await API.post("/users", form);
      setForm({ name: "", email: "" });
      // reload list
      const res = await API.get("/users");
      setUsers(res.data);
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  // 3) Delete a user, then reload
  const handleDelete = async (id) => {
    if (!window.confirm(`Delete user #${id}?`)) return;
    try {
      await API.delete(`/users/${id}`);
      const res = await API.get("/users");
      setUsers(res.data);
     } catch (err) {
      const apiErr = err.response?.data?.message || JSON.stringify(err.response?.data); 
      setError(apiErr || err.message);
    }
  };

  return (
    <div style={sectionStyle}>
      <h3>User Management</h3>
      {error && <div style={errorStyle}>{error}</div>}

      <div style={formRow}>
        <input
          placeholder="Name"
          value={form.name}
          onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))}
        />
        <input
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))}
        />
        <button onClick={handleAdd}>Create</button>
      </div>

      <table style={tableStyle}>
        <thead>
          <tr><th>ID</th><th>Name</th><th>Email</th><th>Action</th></tr>
        </thead>
        <tbody>
          {users.map(u => (
            <tr key={u.id}>
              <td>{u.id}</td>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>
                <button onClick={() => handleDelete(u.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const sectionStyle = {
  border: "1px solid #ccc",
  borderRadius: 6,
  padding: 12,
  marginBottom: 20,
  background: "#f9f9f9"
};
const formRow = { display: "flex", gap: "8px", marginBottom: "12px" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const errorStyle = { color: "red", marginBottom: "8px" };
